
import { useRef } from 'react';

export const useMotivationalMessages = () => {
  const rapidActionsRef = useRef<{ count: number; lastActionTime: number }>({ count: 0, lastActionTime: 0 });
  const rapidActionResetTimer = useRef<NodeJS.Timeout>();

  const detectRapidActions = () => {
    const now = Date.now();
    const timeSinceLastAction = now - rapidActionsRef.current.lastActionTime;
    
    if (timeSinceLastAction < 3000) {
      rapidActionsRef.current.count++;
    } else {
      rapidActionsRef.current.count = 1;
    }
    
    rapidActionsRef.current.lastActionTime = now;
    
    if (rapidActionResetTimer.current) {
      clearTimeout(rapidActionResetTimer.current);
    }
    rapidActionResetTimer.current = setTimeout(() => {
      rapidActionsRef.current.count = 0;
    }, 5000);
    
    return rapidActionsRef.current.count;
  };

  const getContextualMessage = (actionType: 'now-completed' | 'now-skipped' | 'now-missed', rapidCount: number) => {
    console.log(`🎯 Getting contextual message for: ${actionType}, rapid count: ${rapidCount}`);
    
    if (rapidCount >= 3) {
      const fireMessages = [
        "You're on fire! 🔥🔥🔥",
        "Unstoppable momentum! 🚀",
        "Amazing streak! Keep going! ⚡",
        "You're crushing it today! 🌟🔥"
      ];
      return fireMessages[Math.floor(Math.random() * fireMessages.length)];
    }
    
    switch (actionType) {
      case 'now-completed':
        const completedMessages = [
          "Congratulations for showing up! 🌟",
          "You did it! Another step forward! 💪",
          "Amazing! You're building momentum! 🚀",
          "Yes! That's how it's done! ✨",
          "Another win for you! 🎯"
        ];
        return completedMessages[Math.floor(Math.random() * completedMessages.length)];
        
      case 'now-skipped':
        const skippedMessages = [
          "Smart self-care choice! 💙",
          "Rest today, comeback stronger! 🌱",
          "Taking care of yourself matters! 🤗",
          "Good call! Tomorrow awaits! 🌅",
          "Self-awareness is key! 💛"
        ];
        return skippedMessages[Math.floor(Math.random() * skippedMessages.length)];
        
      case 'now-missed':
        const missedMessages = [
          "No worries, fresh start tomorrow! 🔄",
          "Every journey has ups and downs! 💫",
          "Tomorrow is another opportunity! 🌟",
          "Keep going, you've got this! 💪",
          "Progress isn't always linear! 🌈"
        ];
        return missedMessages[Math.floor(Math.random() * missedMessages.length)];
        
      default:
        return "Great job! 👏";
    }
  };

  return {
    detectRapidActions,
    getContextualMessage
  };
};
